<script setup lang="ts">
import { AppInput } from '@shared/ui/inputs'

import {
  useInputSalesTax,
} from '../../../../model/additional-info/support/info-invoice-creation/input-sales-tax.hook'

defineOptions({
  name: 'InputSalesTax',
})

const {
  inputType,
  model,
  placeholder,
} = useInputSalesTax()
</script>

<template>
  <AppInput
    v-model="model"
    :type="inputType"
    :placeholder="placeholder"
  />
</template>
